export function emitCreatorPlanLimitPrompt(payload) {
  if (!payload || payload.code !== 'creator_plan_limit_reached') return false;
  if (typeof window !== 'undefined') {
    const resource = {
      ...(payload.details || {}),
      key: payload?.details?.limitKey || payload?.details?.key || '',
    };
    window.dispatchEvent(new CustomEvent('creator-plan-limit-reached', { detail: resource }));
  }
  return true;
}
